const getters = {
  appConfig: state => state.app.config,
  device: state => state.app.device,
  userPage: state => state.Question.userPage,
  surveyAnswer: state => state.Question.surveyAnswer
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js